import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/test-suites/$id/_layout/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/test-suites/$id/overview',
      params: {
        id: params.id
      }
    });
  }
});